import { autoAddRemoveBy } from "../../cpcoc/autoAddRemoveBy";
import { createSlide } from "../slidesOps/createSlide";
export function slideStandStrongPodcast() {
    if (autoAddRemoveBy(false, new Date("02/06/2025"))) {
        return createSlide({
            autoslide: 30000,
            background: {
                image: "https://cedarparkchurchofchrist.org/media/uploads/src/board/podcast-slide1.png",
            },
        }, `standstrongpodcast`);
    }
    const html = `
        <style>
            @import url('https://fonts.googleapis.com/css2?family=Josefin+Sans&display=swap');

            .ssp-artwork-container {
                perspective: 100vh;
                width: 100%;
                padding-top: 100%;
                position: relative;
            }

            .ssp-artwork {
                width: 100%;
                height: 100%;
                background-image: url('https://www.cedarparkchurchofchrist.org/media/uploads/src/board/stand-strong-podcast/artwork.png');
                background-position: center center;
                background-repeat: no-repeat;
                background-size: cover;
                border-radius: 20px;
                box-shadow: 0 0 100px rgba(0, 0, 0, .9);

                position: absolute;
                left: 0;
                top: 0;
            }

            .present .ssp-artwork {
                animation: rotate-artwork 30s 1 linear;
            }

            .ssp-bg-artwork {
                height: 190vh;
                width: 190vw;
                position: absolute;
                left: -45vw;
                top: -45vh;
                perspective: 100vh;
                opacity: .5;
            }

            .ssp-bg-artwork .ssp-artwork {
                filter: blur(50px);
            }

            .ssp-bg-overlay.ssp-bg-overlay {
                width: 110%;
                height: 110%;
                top: -5%;
                left: 25%;
                transform: skewX(-25deg);
                position: absolute;
                background: linear-gradient(315deg, rgb(36, 50, 55) 0%, rgb(8, 27, 33) 100%);
                opacity: .9;
                box-shadow: inset 50px 0 50px rgb(0 0 0 / 60%);
            }

            .ssp-grid {
                display: grid;
                grid-template-columns: 1fr 1fr;
                column-gap: 4vw;
                width: 90%;
                box-sizing: border-box;
                position: relative;
                z-index: 1;
                max-width: 1700px;
                margin: 0 auto;
            }

            .ssp-content {
                text-align: center;
                position: relative;
            }

            .ssp-title {
                text-transform: uppercase !important;
                color: #fff !important;
                font-family: 'Josefin Sans', sans-serif !important;
                font-size: 4rem !important;
            }

            .ssp-title strong {
                color: #f8bf06;
            }

            .ssp-hr {
                margin: 5vh auto;
                background: #f8bf06;
                width: 25%;
                height: 4px;
            }

            .ssp-text {
                font-family: 'Josefin Sans', sans-serif !important;
                font-size: 3.5rem !important;
            }

            @keyframes rotate-artwork {
                0% {
                    transform: rotateY(0deg) rotateX(0deg);
                }
                12.5% {
                    transform: rotateY(0deg) rotateX(5deg);
                }
                25% {
                    transform: rotateY(5deg) rotateX(10deg);
                }
                37.5% {
                    transform: rotateY(10deg) rotateX(5deg);
                }
                50% {
                    transform: rotateY(10deg) rotateX(0deg);
                }
                62.5% {
                    transform: rotateY(10deg) rotateX(-5deg);
                }
                75% {
                    transform: rotateY(5deg) rotateX(-10deg);
                }
                87.5% {
                    transform: rotateY(0deg) rotateX(-5deg);
                }
                100% {
                    transform: rotateY(0deg) rotateX(0deg);
                }
            }

            .ssp-qrcode {
                width: 50%;
                margin: 0 !important;
                padding: .5vw !important;
                background: #fff;
                box-sizing: border-box;
            }

            .ssp-website {
                position: absolute;
                left: 0;
                right: 0;
            }

            .ssp-website p {
                margin: 0;
                font-size: 1.6rem;
            }

            .ssp-listenon {
                position: absolute;
                left: 0;
                right: 0;
            }

            .ssp-listenon img {
                display: block;
                width: 50%;
                margin: 0 auto 3%;
            }

            #standstrongpodcast .ssp-listenon .fragment {
                transform: translateX(50%);
                opacity: 0;
                transition: transform .5s ease-in-out, opacity .5s ease-in-out;
            }

            #standstrongpodcast.present .ssp-listenon .visible.current-fragment {
                transform: translateX(0);
                opacity: 1;
            }

            #standstrongpodcast .ssp-website.fragment {
                transform: translateX(50%);
                opacity: 0;
                transition: transform .5s ease-in-out, opacity .5s ease-in-out;
            }

            #standstrongpodcast.present .ssp-website.visible.current-fragment {
                transform: translateX(0);
                opacity: 1;
            }
        </style>

        <div style="width: 100%;">
            <div class="ssp-grid" data-id="grid">
                <div class="ssp-artwork-container" data-id="artwork-container">
                    <div class="ssp-artwork animations-to-pause" data-id="artwork"></div>
                </div>
                <div class="ssp-content" data-id="content">
                    <h1 class="ssp-title" data-id="title">
                        New Episodes<br />
                        <strong>Every Monday</strong>
                    </h1>
                    <hr class="ssp-hr" data-id="hr" />
                    <div class="r-stack">
                        <div class="ssp-listenon" data-id="listen-on">
                            <img class="fragment" data-autoslide="15000" data-fragment-index="1" src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/stand-strong-podcast/apple-podcast-badge.svg" alt="Listen on Apple Podcasts" />
                            <img class="fragment" data-fragment-index="1" src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/stand-strong-podcast/spotify-badge.svg" alt="Listen on Spotify" style="transition-delay: .25s;" />
                            <img class="fragment" data-fragment-index="1" src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/stand-strong-podcast/amazon-music-badge.png" alt="Listen on Amazon Music" style="transition-delay: .5s;" />
                        </div>
                        <div class="ssp-website fragment" data-id="qr-website" data-autoslide="15000">
                            <img src="https://www.cedarparkchurchofchrist.org/media/uploads/src/board/stand-strong-podcast/qr-stand-strong.svg" alt="https://bit.ly/3Hwt6TT" data-id="qr-code" class="ssp-qrcode" />
                            <p data-id="text">https://bit.ly/3Hwt6TT</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="ssp-bg-artwork" data-id="bg-artwork-container">
                <div class="ssp-artwork animations-to-pause" data-id="bg-artwork"></div>
            </div>
            <div class="ssp-bg-overlay" data-id="bg-overlay"></div>
        </div>
    `;
    createSlide({
        autoslide: 250,
        center: true,
        wrap: "false",
        html: html,
        background: {
            color: "linear-gradient(315deg, rgba(36,50,55,1) 0%, rgba(8,27,33,1) 100%)",
            gradient: "linear-gradient(315deg, rgba(36,50,55,1) 0%, rgba(8,27,33,1) 100%)",
        },
    }, `standstrongpodcast`);
}
